import { Component, Input, OnChanges, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import {
  AccountMoveModel,
  AccountMoveOwnerContext,
} from 'src/app/shared/store/accounting/types';
import { ContractService } from '../../../../../../shared/store/contract/contract.service';

/**
 * Enveloppe contrat de {@link AccountMovesTabComponent} : elle traduit le contrat courant en
 * {@link AccountMoveOwnerContext} et recharge le contrat quand le tableau le demande.
 */
@Component({
  selector: 'app-contract-details-account-moves',
  templateUrl: './contract-details-account-moves.component.html',
  styleUrls: ['./contract-details-account-moves.component.scss'],
  standalone: false,
})
export class ContractDetailsAccountMovesComponent implements OnInit, OnChanges {
  @Input() accountMoves: AccountMoveModel[];
  @Input() contractId: number;
  @Input() contactId: number;
  @Input() isClient: boolean;
  @Input() contractInsuranceCompanyContactId: number;

  contractUniqueId: string;
  context: AccountMoveOwnerContext;

  constructor(
    private readonly contractService: ContractService,
    private readonly route: ActivatedRoute,
  ) {}

  ngOnInit(): void {
    this.contractUniqueId = this.route.snapshot.params['id'];
  }

  ngOnChanges(): void {
    //objet reconstruit ici et pas dans un getter : un getter en donnerait un nouveau à chaque cycle
    //de détection de changement, et le tableau se réinitialiserait en boucle.
    this.context = {
      ownerType: 'Contract',
      contractId: this.contractId,
      contactId: this.contactId,
      insuranceCompanyContactId: this.contractInsuranceCompanyContactId,
    };
  }

  onRefresh(): void {
    this.contractService.getByUniqueId.call(this.contractUniqueId.toString());
  }
}
